<script lang="ts" setup></script>

<template>
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14 19.5H14.01M9.2 24H18.8C19.9201 24 20.4802 24 20.908 23.782C21.2843 23.5903 21.5903 23.2843 21.782 22.908C22 22.4802 22 21.9201 22 20.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H9.2C8.0799 4 7.51984 4 7.09202 4.21799C6.71569 4.40973 6.40973 4.71569 6.21799 5.09202C6 5.51984 6 6.0799 6 7.2V20.8C6 21.9201 6 22.4802 6.21799 22.908C6.40973 23.2843 6.71569 23.5903 7.09202 23.782C7.51984 24 8.07989 24 9.2 24ZM14.5 19.5C14.5 19.7761 14.2761 20 14 20C13.7239 20 13.5 19.7761 13.5 19.5C13.5 19.2239 13.7239 19 14 19C14.2761 19 14.5 19.2239 14.5 19.5Z"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<style scoped lang="scss">
	svg {
		width: 28px;
		height: 28px;
	}
</style>
